
import { Options, Vue } from 'vue-class-component';
import { mapActions } from 'vuex';
// Types
import { QuizResponse } from '@/types/quiz.d';

@Options({
  props: {
    quiz: {
      type: Object,
      default: {},
    },
  },
  methods: mapActions(['getQuizes']),
})
export default class QuizComponent extends Vue {
  startComponent = false;

  quiz!: QuizResponse;

  getQuizes!: (id: string) => Promise<void>;

  async goQuiz(): Promise<void> {
    this.$router.push('/quiz');
    await this.getQuizes(this.quiz.id);
  }

  mounted(): void {
    this.startComponent = true;
  }
}
